import React from 'react'
import { buildBundleUrl, useFetch } from './services.js'
import { Youtube, LinkedIn, Instagram } from './Icons.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'

const FooterConnectBanner = () => {
  const url = buildBundleUrl('cti-common.footer')
  const { data, isError, isLoading } = useFetch(url)

  if (isError || isLoading)
    return (
      <div className="Footer-connect-min-height u-bgColorBrandDarker u-paddingBottom4gu u-paddingTop4gu"></div>
    )

  const connectHeading = data.bundles.default['connect-heading']
  const subscribeButtonTitle = data.bundles.default['subscribe-button.title']
  const subscribeButtonUrl = data.bundles.default['subscribe-button.url']
  const bundle = [
    {
      key: 'linkedin',
      title: data.bundles.default['social-linkedin.label'],
      url: data.bundles.default['social-linkedin.url'],
      src: LinkedIn,
    },
    {
      key: 'youtube',
      title: data.bundles.default['social-youtube.label'],
      url: data.bundles.default['social-youtube.url'],
      src: Youtube,
    },
    {
      key: 'instagram',
      title: data.bundles.default['social-instagram.label'],
      url: data.bundles.default['social-instagram.url'],
      src: Instagram,
    },
  ]

  return (
    bundle && (
      <div className="u-bgColorBrandDarker u-paddingBottom4gu u-paddingTop4gu">
        <div className="Grid Grid--withGutter u-sizeConstrained u-paddingTop4gu u-sm-textCenter">
          <div className="Footer-subscribeText u-md-size6of12 u-lg-size9of12 u-paddingLeft0">
            <h3 className="u-marginBottom1gu u-textColorWhite">
              Get updates on things you care about
            </h3>
            <p className="u-textColorWhite">
              Sign up for news, topic and product updates that matter{' '}
              <em>most</em> to you.{' '}
            </p>
            <div className="Footer-subscribeButton u-marginBottom4gu u-marginTop4gu">
              <a
                className="Button Button--secondary Button--reversed"
                data-analytics="cesc-subscribe-link"
                data-qa-automation="subscribe-button"
                href={subscribeButtonUrl}
                target="_blank"
                title={subscribeButtonTitle}
                rel="noreferrer"
              >
                <span className="Icon--material u-textSizeMsr u-marginRight1gu Footer-subscribeIcon">
                  mail_outline
                </span>
                Choose subscriptions
              </a>
            </div>
          </div>
          <div className="Footer-social u-marginBottom6gu u-md-size6of12 u-lg-size3of12">
            <h4 className="u-marginBottom2gu u-textColorWhite">
              {connectHeading}
            </h4>
            {bundle.map((item) => {
              const Icon = item.src
              return (
                <a
                  key={item.key}
                  className="Link Footer-socialLink u-inlineBlock u-marginRight1gu"
                  href={item.url}
                  title={item.title}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="u-hiddenVisually">{item.title}</span>
                  <svg
                    aria-hidden="true"
                    className="FooterSocialSvg"
                    viewBox="0 0 100 100"
                  >
                    <Icon />
                  </svg>
                </a>
              )
            })}
          </div>
        </div>
      </div>
    )
  )
}

export default function ErrorWrapperFooterConnectBanner(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? <p>Error in FooterConnectBanner component</p> : null
      }
    >
      <FooterConnectBanner {...props}></FooterConnectBanner>
    </ErrorBoundary>
  )
}
